import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { RecordingStatus } from "./types";

export const recordingStatusAtom = atom<RecordingStatus>("idle");
export const recordedVisitIdAtom = atomWithStorage<string | null>(
  "recorded-visit-id",
  null,
);
export const mediaRecorderAtom = atom<MediaRecorder | null>(null);
export const isJabraConnectedAtom = atom(false);
